// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3dS27","selects":"Documents_selects__14dsM"};